import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { syncDocumentHead, type HeadDoc } from '../headSync'

/**
 * Keeps document head metadata in sync during client-side (SPA) navigation.
 * The prerendered HTML is correct on initial load; this handles subsequent
 * in-app route changes (title, description, canonical, robots, Open Graph,
 * and route-specific JSON-LD — including removing homepage JSON-LD when
 * navigating to a child page).
 */
export default function HeadSync() {
  const { pathname } = useLocation()
  useEffect(() => {
    syncDocumentHead(pathname, document as unknown as HeadDoc)
  }, [pathname])
  return null
}
